import React, {
    useState,
    useEffect,
    useContext,
    useRef
}
from "react";

import { store }
from "../../context/store";

import { functions }
from "../../constants/common-functions";

import {
    COLOR_UTILISATION_OCCUPIED,
    COLOR_UTILISATION_SIGNS_OF_LIFE,
    COLOR_UTILISATION_VACANT,
    OMNISCAN_CORPORATE_TURQUOIS
}
from "../../constants/colors";

import {
    FALSE,
    UTILISATION_SHOW_DESK,
    UTILISATION_DASHBOARD_TYPE_SOL
}
from "../../constants/general-constants";

import {
    CARD_STYLE,
    CHART_CONTAINER_STYLE
}
from "../../constants/styles";

import {
    EMPTY_FILTER_BEAN
}
from "../../constants/filter-constants";

import {
    childDashboardsUtilisation
}
from "../../constants/dashboards-children";

import {
    nonStandardUtilisationUrls
}
from "../../constants/client-specifics";

import {
    JWT
}
from "../../constants/local-storage";

import {
    useHistory,
    useParams
}
from "react-router-dom";

import Header
from "../../components/Header";

import LeftMenu
from "../../components/LeftMenu";

import DashboardSelector
from "../../components/DashboardSelector";

import DashboardPhotoNavigator
from "../../components/DashboardPhotoNavigator";

import AmChartSimpleBar
from "../../components/AmChartSimpleBar";

import AmChartDateLine
from "../../components/AmChartDateLine";

import AmChartRingIndicator
from "../../components/AmChartRingIndicator";

import UtilisationKpiBox
from "../utilisation/components/UtilisationKpiBox";

import UtilisationKpiBoxDate
from "../utilisation/components/UtilisationKpiBoxDate";

import UtilisationChartProfileUnused
from "../utilisation/components/UtilisationChartProfileUnused";

import UtilisationChartEfficiency
from "../utilisation/components/UtilisationChartEfficiency";

import UtilisationOrganisationNavigator
from "../utilisation/components/UtilisationOrganisationNavigator";

import MobileUtilisationAll
from "./mobile/MobileUtilisationAll";


import "./UtilisationAll.css";


export default function UtilisationAll()
{
    //--------------------------------------------------------
    // Context / routing
    //--------------------------------------------------------

    const globalState =
        useContext(store);

    const history =
        useHistory();

    const refFacility =
        useRef(null);

    const facilityIdParam =
        useParams()["facilityId"];

    const spaceTypeIdParam =
        useParams()["spaceTypeId"];

    const queryContext =
        globalState?.state?.queryContext;


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [utilisationAvg, setUtilisationAvg] =
        useState(0);

    const [utilisationMax, setUtilisationMax] =
        useState(0);

    const [seats, setSeats] =
        useState(0);

    const [observations, setObservations] =
        useState(0);

    const [datePeak, setDatePeak] =
        useState("");

    const [dateMin, setDateMin] =
        useState("");

    const [timePeak, setTimePeak] =
        useState("");

    const [timeMin, setTimeMin] =
        useState("");

    const [dataByFacility, setDataByFacility] =
        useState([]);

    const [dataByFloor, setDataByFloor] =
        useState([]);

    const [dataBySpace, setDataBySpace] =
        useState([]);

    const [leftBarChartData, setLeftBarChartData] =
        useState([]);

    const [loaded, setLoaded] =
        useState(false);

    const [leftBarChartHeight, setLeftBarChartHeight] =
        useState("100px");

    const [displayRoomTable, setDisplayRoomTable] =
        useState("none");

    const [displayGroupChart, setDisplayGroupChart] =
        useState("flex");

    const [facility, setFacility] =
        useState({});

    const [dataTimeline, setDataTimeline] =
        useState([]);

    const [filterBean, setFilterBean] =
        useState(EMPTY_FILTER_BEAN);

    const [facilityId, setFacilityId] =
        useState(-100);

    const [floorId, setFloorId] =
        useState(-100);

    const [floorZoneId, setFloorZoneId] =
        useState(-100);

    const [spaceId, setSpaceId] =
        useState(-100);

    const [spaceTypeId, setSpaceTypeId] =
        useState(-100);

    const [parentSpaceTypeId, setParentSpaceTypeId] =
        useState(-100);

    const [organisationId, setOrganisationId] =
        useState(-100);

    const [parentOrganisationId, setParentOrganisationId] =
        useState(-100);

    const [showCoreDayOnly, setShowCoreDayOnly] =
        useState(0);

    const [showDesksMeetings, setShowDesksMeetings] =
        useState(-100);


    //--------------------------------------------------------
    // Initialisation
    //--------------------------------------------------------

    useEffect(() =>
    {
        if(nonStandardUtilisationUrls.includes(window.location.hostname))
        {
            history.push(
                "/utilisationallnonstandard/" + facilityIdParam
            );
        }

    }, [facilityId]);


    useEffect(() =>
    {
        if(loaded)
        {
            return;
        }

        resetSearch();

        setLoaded(true);

    }, []);


    useEffect(() =>
    {
        setParentSpaceTypeId(
            spaceTypeIdParam
        );

        if(setFilterBean)
        {
            setFilterBean(
                {
                    ...EMPTY_FILTER_BEAN,

                    spaceTypes:
                        spaceTypeIdParam !== "-100"
                            ? [parseInt(spaceTypeIdParam)]
                            : []
                }
            );
        }

    }, [spaceTypeIdParam]);


    //--------------------------------------------------------
    // Load dashboard data
    //--------------------------------------------------------

    useEffect(() =>
    {
        if(parentSpaceTypeId === -100)
        {
            return;
        }

        functions.postFilterBeanAjax(
            "/resolutionsoftwareplatform/utilisationstandardgetaverage",
            functions.buildPostBodyFilterBeanQueryContext(
                filterBean,
                queryContext
            ),
            populateUtilisationAvg
        );

        functions.postFilterBeanAjax(
            "/resolutionsoftwareplatform/utilisationstandardgetmax",
            functions.buildPostBodyFilterBeanQueryContext(
                filterBean,
                queryContext
            ),
            populateUtilisationMax
        );

        functions.postFilterBeanAjax(
            "/resolutionsoftwareplatform/utilisationstandardgetcapacity",
            functions.buildPostBodyFilterBeanQueryContext(
                filterBean,
                queryContext
            ),
            populateSeats
        );

        functions.postFilterBeanAjax(
            "/resolutionsoftwareplatform/utilisationstandardgetobservations",
            functions.buildPostBodyFilterBeanQueryContext(
                filterBean,
                queryContext
            ),
            populateObservations
        );

        functions.postFilterBeanAjax(
            "/resolutionsoftwareplatform/utilisationstandardgetdatemax",
            functions.buildPostBodyFilterBeanQueryContext(
                filterBean,
                queryContext
            ),
            calculateDatePeak
        );

        functions.postFilterBeanAjax(
            "/resolutionsoftwareplatform/utilisationstandardgetdatemin",
            functions.buildPostBodyFilterBeanQueryContext(
                filterBean,
                queryContext
            ),
            calculateDateMin
        );


        //----------------------------------------------------
        // Breakdown chart
        //----------------------------------------------------

        if(facilityId === "-100")
        {
            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetavgbyfacility",
                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),
                populateDataByFacility
            );
        }
        else if(floorId === "-100")
        {
            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetavgbyfloor",
                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),
                populateDataByFloor
            );
        }
        else if(spaceId === "-100")
        {
            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetavgbyspace",
                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),
                populateDataBySpace
            );
        }


        loadDataTimeline();

    }, [
        parentSpaceTypeId,
        filterBean,
        queryContext?.utilisationSurveyId
    ]);


    useEffect(() =>
    {
        setLeftBarChartHeight(
            (20 * leftBarChartData.length + 100) + "px"
        );

    }, [leftBarChartData]);


    //--------------------------------------------------------
    // Timeline
    //--------------------------------------------------------

    const loadDataTimeline = () =>
    {
        functions.postFilterBeanAjax(
            "/resolutionsoftwareplatform/utilisationgetbydatewithoutfilterandsignsoflife",
            functions.buildPostBodyFilterBeanQueryContext(
                filterBean,
                queryContext
            ),
            handleDataTimeline
        );
    };


    const handleDataTimeline = (results) =>
    {
        const tempData =
            results.map(
                ({
                    label,
                    vacant,
                    occupied,
                    signsOfLife
                }) =>
                ({
                    id:
                        label,

                    date:
                        functions.convertUtilisationLabelToDate(
                            label
                        ),

                    vacant:
                        parseInt(vacant),

                    occupied:
                        parseInt(occupied),

                    signsOfLife:
                        parseInt(signsOfLife)
                })
            );

        setDataTimeline(
            tempData
        );
    };


    //--------------------------------------------------------
    // Reset
    //--------------------------------------------------------

    const resetSearch = () =>
    {
        setFacilityId(
            facilityIdParam || -100
        );

        setFloorId(-100);
        setFloorZoneId(-100);
        setSpaceId(-100);
        setSpaceTypeId(-100);
        setOrganisationId(-100);
        setParentOrganisationId(-100);
        setShowCoreDayOnly(0);
    };


    //--------------------------------------------------------
    // KPI callbacks
    //--------------------------------------------------------

    const populateSeats = (obj) =>
    {
        setSeats(
            obj.returnDouble
        );
    };


    const populateObservations = (obj) =>
    {
        setObservations(
            obj.returnDouble
        );
    };


    const populateUtilisationMax = (obj) =>
    {
        let thisValue =
            obj.returnDouble;

        if(parseInt(thisValue) > 100)
        {
            setUtilisationMax(100);
        }
        else
        {
            setUtilisationMax(
                obj.returnDouble
            );
        }
    };


    const populateUtilisationAvg = (obj) =>
    {
        setUtilisationAvg(
            obj.returnDouble
        );
    };


    const calculateDatePeak = (input) =>
    {
        setTimePeak(
            input.hour
        );

        setDatePeak(
            input.returnDate
        );
    };


    const calculateDateMin = (input) =>
    {
        setTimeMin(
            input.hour
        );

        setDateMin(
            input.returnDate
        );
    };


    //--------------------------------------------------------
    // Breakdown data
    //--------------------------------------------------------

    const populateDataByFacility = (results) =>
    {
        let tempDataByFacility =
            [];

        for(let i = 0; i < results.length; i++)
        {
            tempDataByFacility.push(
                {
                    id:
                        results[i].id,

                    label:
                        results[i].name,

                    value:
                        results[i].avg
                }
            );
        }

        setLeftBarChartData(
            tempDataByFacility
        );

        setDataByFacility(
            tempDataByFacility
        );
    };


    const populateDataByFloor = (results) =>
    {
        let tempDataByFloor =
            [];

        for(let i = 0; i < results.length; i++)
        {
            tempDataByFloor.push(
                {
                    id:
                        results[i].id,

                    label:
                        results[i].name,

                    value:
                        results[i].avg
                }
            );
        }

        setLeftBarChartData(
            tempDataByFloor
        );

        setDataByFloor(
            tempDataByFloor
        );
    };


    const populateDataBySpace = (results) =>
    {
        let tempDataBySpace =
            [];

        for(let i = 0; i < results.length; i++)
        {
            tempDataBySpace.push(
                {
                    id:
                        results[i].id,

                    label:
                        results[i].code,

                    value:
                        results[i].avg
                }
            );
        }

        setLeftBarChartData(
            tempDataBySpace
        );

        setDataBySpace(
            tempDataBySpace
        );
    };


    //--------------------------------------------------------
    // Navigation
    //--------------------------------------------------------

    const clickFacility = (id) =>
    {
        refFacility.current.value =
            id;

        setFacilityId(
            id
        );
    };


    const clickSpace = (id) =>
    {
        setSpaceId(
            id
        );
    };


    const clickFloor = (id) =>
    {
        setFloorId(
            id
        );
    };


    const goSite = () =>
    {
        setFacilityId("-100");
        setFloorId("-100");
        setSpaceId("-100");
    };


    const handleChangeFacility = (e) =>
    {
        setFacilityId(
            e.target.value
        );

        if(e.target.value === "-100")
        {
            setSpaceId("-100");
            setFloorId("-100");
        }
    };


    const handleChangeFloor = (e) =>
    {
        setFloorId(
            e.target.value
        );

        if(e.target.value === "-100")
        {
            setSpaceId("-100");
        }
    };


    const handleChangeSpace = (e) =>
    {
        setSpaceId(
            e.target.value
        );
    };


    const handleBarClick = (id) =>
    {
        if(facilityId === "-100")
        {
            clickFacility(id);
        }
        else if(floorId === "-100")
        {
            clickFloor(id);
        }
        else
        {
            clickSpace(id);
        }
    };


    //--------------------------------------------------------
    // Graph definitions
    //--------------------------------------------------------

    const dataByDateGraphsStacked =
    [
        {
            id:
                "occupied",

            title:
                "Occupied",

            keyColumn:
                "occupied",

            color:
                COLOR_UTILISATION_OCCUPIED
        },

        {
            id:
                "signsOfLife",

            title:
                "Signs Of Life",

            keyColumn:
                "signsOfLife",

            color:
                COLOR_UTILISATION_SIGNS_OF_LIFE
        },

        {
            id:
                "vacant",

            title:
                "Available",

            keyColumn:
                "vacant",

            color:
                COLOR_UTILISATION_VACANT
        }
    ];


    //--------------------------------------------------------
    // Tile design
    //--------------------------------------------------------

    const TILE_GAP =
        "8px";

    const TILE_RADIUS =
        "8px";


    const tileTopLeft =
    {
        borderTopLeftRadius:
            TILE_RADIUS
    };


    const tileTopRight =
    {
        borderTopRightRadius:
            TILE_RADIUS
    };


    const tileBottomLeft =
    {
        borderBottomLeftRadius:
            TILE_RADIUS
    };


    const tileBottomRight =
    {
        borderBottomRightRadius:
            TILE_RADIUS
    };


    //--------------------------------------------------------
    // Layout
    //--------------------------------------------------------

    const thisContainer =
    {
        display:
            "flex",

        position:
            "fixed",

        flexDirection:
            "column",

        width:
            "100%",

        minHeight:
            "100vh",

        left:
            "0px",

        top:
            "0px",

        zIndex:
            "1"
    };


	//========================================================
	// Main Dashboard Container
	//========================================================

	const mainContainer =
	{
	    position: "fixed",

	    top: "0px",
	    left: "60px",
	    bottom: "0px",
	    right: "0px",

	    overflow: "auto",

	    zIndex: "0",

	    paddingTop: "90px",

	    background: "transparent"
	};


    /*
     * Main dashboard grid.
     *
     * Left column  = breakdown
     * Right column = dashboard tiles
     */

    const dashboardGrid =
    {
        display:
            "grid",

        gridTemplateColumns:
            "419px minmax(0, 1fr)",

        gap:
            TILE_GAP,

        width:
            "calc(100% - 40px)",

        margin:
            "20px",

        alignItems:
            "stretch"
    };


    //--------------------------------------------------------
    // Left tile
    //--------------------------------------------------------

    const leftContainer =
    {
        display:
            "flex",

        flexDirection:
            "column",

        minWidth:
            "0",

        minHeight:
            "calc(100vh - 130px)",

        ...tileTopLeft,
        ...tileBottomLeft
    };


    const barChartContainer =
    {
        display:
            "flex",

        width:
            "100%",

        minHeight:
            "200px",

        flex:
            "1"
    };


    //--------------------------------------------------------
    // Right tile grid
    //--------------------------------------------------------

    const rightGrid =
    {
        display:
            "grid",

        gridTemplateColumns:
            "repeat(4, minmax(0, 1fr))",

        /*
         * Row 1: KPI / doughnut area
         * Row 2: two charts
         * Row 3: timeline
         */

        gridTemplateRows:
            "180px minmax(240px, auto) minmax(300px, auto)",

        gap:
            TILE_GAP,

        minWidth:
            "0"
    };


    //--------------------------------------------------------
    // Doughnut tiles
    //--------------------------------------------------------

    const doughnutTile =
    {
        display:
            "flex",

        flexDirection:
            "column",

        alignItems:
            "center",

        justifyContent:
            "center",

        minWidth:
            "0",

        minHeight:
            "0"
    };


    //--------------------------------------------------------
    // KPI tile
    //--------------------------------------------------------

	const boxIndicatorContainer =
	{
	    display:
	        "flex",

	    flexWrap:
	        "wrap",

	    alignContent:
	        "center",

	    justifyContent:
	        "center",

	    columnGap:
	        "20px",

	    rowGap:
	        "8px",

	    padding:
	        "16px",

	    boxSizing:
	        "border-box",

	    minWidth:
	        "0",

	    minHeight:
	        "0",

	    ...tileTopRight
	};


    //--------------------------------------------------------
    // Middle chart tile
    //--------------------------------------------------------

    const middleChartTile =
    {
        display:
            "flex",

        flexDirection:
            "column",

        minWidth:
            "0",

        minHeight:
            "240px",

        paddingTop:
            "10px"
    };


    //--------------------------------------------------------
    // Timeline tile
    //--------------------------------------------------------

    const timelineTile =
    {
        display:
            "flex",

        flexDirection:
            "column",

        minWidth:
            "0",

        minHeight:
            "300px",

        ...tileBottomRight
    };


    //--------------------------------------------------------
    // Titles
    //--------------------------------------------------------

    const chartTitle =
    {
        display:
            "flex",

        width:
            "100%",

        height:
            "20px",

        fontSize:
            "12px",

        fontWeight:
            "bold",

        alignItems:
            "center",

        justifyContent:
            "space-around"
    };


    //--------------------------------------------------------
    // Mobile
    //--------------------------------------------------------

    const isMobile =
        window.innerWidth <= 768;


    if(isMobile)
    {
        return (
            <MobileUtilisationAll/>
        );
    }


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (
        <div style={thisContainer}>

            <Header
                transitionHide={true}
                showSurveySelector={true}
            />

            <LeftMenu/>


            <DashboardSelector
                title="Utilisation Dashboard"
                childDashboards={childDashboardsUtilisation}
            />


			<div
			    className="utilisation-all-main"
			    style={mainContainer}
			>

                <div style={dashboardGrid}>


                    {/* ------------------------------------------------
                        LEFT ANALYSIS TILE
                    ------------------------------------------------ */}

                    <div
						className="utilisation-all-tile"
                        style={{
                            ...CARD_STYLE,
                            ...leftContainer
                        }}
                    >

                        <div style={barChartContainer}>

                            <div style={CHART_CONTAINER_STYLE}>

                                <AmChartSimpleBar
                                    chartId="utilisationallleftbar"
                                    chartData={leftBarChartData}
                                    categoryKey="label"
                                    valueKey="value"
                                    width="100%"
                                    height={leftBarChartHeight}
                                    onClick={handleBarClick}
                                    color={COLOR_UTILISATION_OCCUPIED}
                                />

                            </div>

                        </div>


                        <div style={chartTitle}>

                            Breakdown by Building/Floor/Workplace

                        </div>

                    </div>


                    {/* ------------------------------------------------
                        RIGHT DASHBOARD GRID
                    ------------------------------------------------ */}

                    <div style={rightGrid}>


                        {/* Average */}

                        <div
							className="utilisation-all-tile"
                            style={{
                                ...CARD_STYLE,
                                ...doughnutTile
                            }}
                        >

                            <div
                                style={{
                                    ...CHART_CONTAINER_STYLE,

                                    height:
                                        "140px",

                                    alignItems:
                                        "center",

                                    justifyContent:
                                        "center"
                                }}
                            >

                                <AmChartRingIndicator
                                    percentage={utilisationAvg}
                                    width={130}
                                    height={130}
                                    icon="chair"
                                    color={COLOR_UTILISATION_OCCUPIED}
                                    label="Avg"
                                    id="utilisationalldoughnutavg"
                                />

                            </div>

                        </div>


                        {/* Peak */}

                        <div
							className="utilisation-all-tile"
                            style={{
                                ...CARD_STYLE,
                                ...doughnutTile
                            }}
                        >

                            <div
                                style={{
                                    ...CHART_CONTAINER_STYLE,

                                    height:
                                        "140px",

                                    alignItems:
                                        "center",

                                    justifyContent:
                                        "center"
                                }}
                            >

                                <AmChartRingIndicator
                                    percentage={utilisationMax}
                                    width={130}
                                    height={130}
                                    icon="chair"
                                    color={COLOR_UTILISATION_OCCUPIED}
                                    label="Peak"
                                    id="utilisationalldoughnutmin"
                                />

                            </div>

                        </div>


                        {/* KPI block */}

                        <div
							className="utilisation-all-tile"
                            style={{
                                ...CARD_STYLE,
                                ...boxIndicatorContainer,

                                gridColumn:
                                    "3 / 5"
                            }}
                        >

                            <UtilisationKpiBox
                                title="Seats"
                                figure={
                                    functions.formatNumber(
                                        seats,
                                        0
                                    )
                                }
                                color={OMNISCAN_CORPORATE_TURQUOIS}
                                width="calc(50% - 30px)"
                            />


                            <UtilisationKpiBox
                                title="Observations"
                                figure={
                                    functions.formatNumber(
                                        observations,
                                        0
                                    )
                                }
                                color={OMNISCAN_CORPORATE_TURQUOIS}
                                width="calc(50% - 30px)"
                            />


                            <UtilisationKpiBoxDate
                                title="Max On"
                                figure={
                                    functions.formatDate(
                                        datePeak
                                    )
                                }
                                hour={timePeak}
                                width="calc(50% - 30px)"
                            />


                            <UtilisationKpiBoxDate
                                title="Min On"
                                figure={
                                    functions.formatDate(
                                        dateMin
                                    )
                                }
                                hour={timeMin}
                                width="calc(50% - 30px)"
                            />

                        </div>


                        {/* Weekly / daily profile */}

                        <div
							className="utilisation-all-tile"
                            style={{
                                ...CARD_STYLE,
                                ...middleChartTile,

                                gridColumn:
                                    "1 / 3"
                            }}
                        >

                            <UtilisationChartProfileUnused
                                id="utilisationchartprofileunuseddesks"
                                filterBean={filterBean}
                                isMeeting={FALSE}
                            />

                        </div>


                        {/* Efficiency */}

                        <div
							className="utilisation-all-tile"
                            style={{
                                ...CARD_STYLE,
                                ...middleChartTile,

                                gridColumn:
                                    "3 / 5"
                            }}
                        >

                            <UtilisationChartEfficiency
                                id="utilisationchartefficiencydesks"
                                filterBean={filterBean}
                                isMeeting={FALSE}
                            />

                        </div>


                        {/* Timeline */}

                        <div
							className="utilisation-all-tile"
                            style={{
                                ...CARD_STYLE,
                                ...timelineTile,

                                gridColumn:
                                    "1 / 5"
                            }}
                        >

                            <div style={CHART_CONTAINER_STYLE}>

                                <AmChartDateLine
                                    chartId="utilisationalltimelinestackchart"
                                    width="100%"
                                    height="270px"
                                    chartData={dataTimeline}
                                    graphs={dataByDateGraphsStacked}
                                    dateKey="date"
                                    isStacked={true}
                                />

                            </div>


                            <div
                                style={{
                                    ...chartTitle,

                                    marginTop:
                                        "-5px",

                                    paddingBottom:
                                        "10px"
                                }}
                            >

                                Utilisation Profile

                            </div>

                        </div>

                    </div>

                </div>

            </div>


            <UtilisationOrganisationNavigator
                dashboardType={UTILISATION_DASHBOARD_TYPE_SOL}
                selectedParentSpaceTypeId={parentSpaceTypeId}
            />


            <DashboardPhotoNavigator
                refFacility={refFacility}

                facilityId={facilityId}
                setFacilityId={setFacilityId}

                floorId={floorId}
                setFloorId={setFloorId}

                floorZoneId={floorZoneId}
                setFloorZoneId={setFloorZoneId}

                spaceId={spaceId}
                setSpaceId={setSpaceId}

                spaceTypeId={spaceTypeId}
                setSpaceTypeId={setSpaceTypeId}

                parentSpaceTypeId={parentSpaceTypeId}
                setParentSpaceTypeId={setParentSpaceTypeId}

                organisationId={organisationId}
                setOrganisationId={setOrganisationId}

                parentOrganisationId={parentOrganisationId}
                setParentOrganisationId={setParentOrganisationId}

                showCoreDayOnly={showCoreDayOnly}
                setShowCoreDayOnly={setShowCoreDayOnly}

                showDesksMeetings={showDesksMeetings}
                setShowDesksMeetings={setShowDesksMeetings}

                resetFunction={resetSearch}

                utilisationDeskMeetingRemainder={UTILISATION_SHOW_DESK}

                setFilterBean={setFilterBean}
            />

        </div>
    );
}